var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-comparison-stat"},[(_vm.title)?_c('h4',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('q-progress-stat',{attrs:{"value":_vm.value,"format":_vm.format,"max":_vm.max,"color":_vm.color,"animate":_vm.animate,"interval":_vm.interval,"height":_vm.height,"append":_vm.appended_text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }